// client/src/pages/Home/Home.js
// Landningssida. Hero + choice cards som länkar till /reports och /smittlage.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Home.css';

const Home = () => {
  const { t } = useTranslation();
  return (
    <div className="home-page">
      {/* Animated Background Gradient */}
      <div className="background-gradient" />

      {/* Main Content - Navigation handled globally by App.js */}
      <main className="home-main">
        {/* Hero Section */}
        <section className="hero">
          <h1 className="hero-title">{t('home.heroTitle')}</h1>
          <p className="hero-subtitle">
            {t('home.heroSubtitle')}
          </p>
        </section>

        {/* Choice Cards */}
        <div className="choice-container">
          {/* Symptom Report Card */}
          <Link to="/reports" className="choice-card symptom">
            <div className="card-icon">🤒</div>
            <h2 className="card-title">{t('home.symptomCardTitle')}</h2>
            <p className="card-description">
              {t('home.symptomCardDesc')}
            </p>
            <div className="card-arrow">→</div>
          </Link>

          {/* View Spread Card */}
          <Link to="/smittlage" className="choice-card map">
            <div className="card-icon">🗺️</div>
            <h2 className="card-title">{t('home.mapCardTitle')}</h2>
            <p className="card-description">
              {t('home.mapCardDesc')}
            </p>
            <div className="card-arrow">→</div>
          </Link>
        </div>

        {/* Footer Hint */}
        <p className="footer-hint">
          {t('home.footerHint')}
        </p>
      </main>
    </div>
  );
};

export default Home;
